export const EXECUTE_RE_CAPTCHA_RESULT_TYPE = {
  notUsed: 'notUsed',
  success: 'success',
  error: 'error',
} as const;
